(function(window, $) {
  var candidateSequence = 0;

  window.jpostalPreservingInput = function(selector, options) {
    var originalAddress = options.address || {};
    var guardedAddress = {};
    var addressTargets = {};
    var lastAutoValues = {};

    $.each(originalAddress, function(targetSelector, format) {
      var $target = $(targetSelector);
      if ($target.length === 0) {
        return;
      }

      candidateSequence += 1;
      var candidateId = 'jpostal_candidate_' + candidateSequence;
      $('<input>', { type: 'hidden', id: candidateId }).insertAfter($target);

      guardedAddress['#' + candidateId] = format;
      addressTargets['#' + candidateId] = targetSelector;
    });

    var copyAddressIfBlankOrAutoFilled = function() {
      $.each(addressTargets, function(candidateSelector, targetSelector) {
        var $target = $(targetSelector);
        var candidateValue = $(candidateSelector).val();
        var currentValue = $target.val();

        if ($.trim(candidateValue) === '') {
          return;
        }

        if ($.trim(currentValue) === '' || currentValue === lastAutoValues[targetSelector]) {
          $target.val(candidateValue);
          lastAutoValues[targetSelector] = candidateValue;
        }
      });
    };

    var guardedTrigger = $.extend({}, options.trigger || {});
    $.each(addressTargets, function(candidateSelector) {
      guardedTrigger[candidateSelector] = true;
      $(candidateSelector).on('change', copyAddressIfBlankOrAutoFilled);
    });

    var guardedOptions = $.extend({}, options, { address: guardedAddress, trigger: guardedTrigger });
    $(selector).jpostal(guardedOptions);

    var postcodes = typeof options.postcode === 'string' ? [options.postcode] : options.postcode;
    $.each(postcodes, function(_, postcodeSelector) {
      $(postcodeSelector).on('keyup change', copyAddressIfBlankOrAutoFilled);
    });
  };
})(window, jQuery);
